import { Component, OnInit } from '@angular/core';
import { HelperService } from '../service/helper/helper.service';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-createwallet',
  templateUrl: './createwallet.component.html',
  styleUrls: ['./createwallet.component.css']
})
export class CreatewalletComponent implements OnInit {

  public seed;
  rawSeed
  public passKey;
  public confirmPassKey;
  public repassKey;
  constructor(public router: Router, public helper: HelperService) { }

  ngOnInit() {
    this.rawSeed = this.helper.generateSeed();
    this.seed = this.rawSeed.split(" ", 12)
    // console.log("Raw seed after split: ", this.rawSeed)
  }

  regenerate() {
    this.rawSeed = this.helper.generateSeed();
    this.seed = this.rawSeed.split(" ", 12)
  }
  downloadAsText() {
    this.helper.saveAsFile(this.rawSeed);
    // let cyp = this.helper.encrypt(this.seed);
    // let decryp = this.helper.decrypt(cyp);
    // console.log(cyp)
    // console.log(decryp)
  }
  confirmSeed() {
    if (!this.passKey) {
      Swal.fire({
        title: 'Error',
        text: 'Please enter wallet PIN',
        type: 'info'
      })
      this.passKey = '';
      return;
    }
    else if(this.passKey != this.confirmPassKey){
      Swal.fire({
        title: 'Error',
        text: 'Passkeys doesn\'t match',
        type: 'info'
      })
      this.passKey = '';
      this.confirmPassKey = '';
      return;
    }
    else{
      Swal.fire({
        title: '',
        text: "Please download the seed phrase first, and then hit 'Create'",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Create'
      }).then((result) => {
        if (result.value) {
          Swal.fire(
            'Created',
            'Your NIT wallet has been created.',
            'success'
          )
          this.helper.encrypt(this.rawSeed, this.passKey);
      this.router.navigate(['login']);
        }
      })

    }

  }


  back() {
    this.router.navigate(['login']);
  }
}
